import { BoxProps, Text } from "@chakra-ui/react";
import { Box } from "@chakra-ui/react";

const ValidatedField = ({
  name,
  children = <></>,
  errors,
  ...boxProps
}: {
  name: string;
  children?: React.ReactNode;
  errors: any;
} & BoxProps) => {
  const error = errors[name];
  const errorMessage = error?.message || 
    (typeof error === 'object' && error?.type === 'min' && error?.message) ||
    (typeof error === 'object' && error?.type === 'max' && error?.message) ||
    (typeof error === 'object' && error?.type === 'has-phone' && error?.message);

  return (
    <Box w="full" {...boxProps}>
      {children}
      <Box h={4}>
        {errorMessage ? (
          <Text fontSize={"sm"} color="red.300">
            {errorMessage}
          </Text>
        ) : null}
      </Box>
    </Box>
  );
};

export default ValidatedField;
